import { ALLOWED_COLORS, ALLOWED_SIZES, ALLOWED_TEXT_ALIGNS, ALLOWED_WEIGHTS, sanitizeAllowedString, sanitizeBindable, sanitizeFormattableBindable, sanitizeString } from './helpers';
export function sanitizeTextBlock(el) {
  const text = sanitizeFormattableBindable(el.text, sanitizeString);
  if (!text) return null;
  return {
    type: 'TextBlock',
    text,
    size: sanitizeBindable(el.size, v => sanitizeAllowedString(v, ALLOWED_SIZES)),
    weight: sanitizeBindable(el.weight, v => sanitizeAllowedString(v, ALLOWED_WEIGHTS)),
    color: sanitizeBindable(el.color, v => sanitizeAllowedString(v, ALLOWED_COLORS)),
    align: sanitizeBindable(el.align, v => sanitizeAllowedString(v, ALLOWED_TEXT_ALIGNS))
  };
}